
<template>
<div>
  <chc-modal ref="addNoteModal" title="New Note">
    <div slot="body">
      <vehicle-add-note :vehicleId="vehicleId"
                        v-on:refresh="refreshNotes"
                        v-on:close="addNoteHide">
      </vehicle-add-note>
    </div>
  </chc-modal>
  <section class="wrapper vehicle-detail">
    <div class="vehicle-detail-header">
      <div class="vehicle-status">
        <h1> {{ data.ref_number }} </h1>
        <!--<chc-input v-if="user.user_role == 'admin'"
                   id="donation-status"
                   v-model="data.status"
                   label="Status"
                   format="combo"
                   class="top-status"
                   :autoCompleteValues="$store.state.constants.vehicle.vehicle_status"></chc-input>-->
        <dt class="data-label">Status</dt>
        <dd class="data-content"> {{ data.formated_status }} </dd>
      </div>
      <dl v-if="user.user_role != 'admin'">
        <dt class="data-label">Status</dt>
        <dd class="data-content"> {{ data.formated_status }} </dd>
      </dl>
      <dl>
        <dt class="data-label">Entry Date</dt>
        <dd class="data-content"> {{ data.entry_date }} </dd>
      </dl>
      <dl>
        <dt class="data-label">Sold Date</dt>
        <dd class="data-content"> {{ data.sold_date }} </dd>
      </dl>
      <dl>
        <dt class="data-label">Charity</dt>
        <dd class="data-content"> {{ data.charity }} </dd>
      </dl>
      <dl>
        <dt class="data-label">Buyer</dt>
        <dd class="data-content"> {{ data.buyer }} </dd>
      </dl>
    </div>
    <chc-tab-control>
      <chc-tab-pane label="Donor Information">
        <vehicle-donor-info :vehicleId="vehicleId" :data="donorData" @refresh="refresh" ref="donorInfo">
        </vehicle-donor-info>
      </chc-tab-pane>
      <chc-tab-pane label="Vehicle Information">
        <vehicle-detail-info :vehicleId="vehicleId" :data="vehicleDetailData" @refresh="refresh">
        </vehicle-detail-info>
      </chc-tab-pane>
      <chc-tab-pane label="Processing" v-if="user.user_role == 'admin'">
        <vehicle-processing  :data="processingData" :vehicleId="vehicleId" :donorData="donorData" :refNum="data.ref_number" @refresh="refresh"></vehicle-processing>
      </chc-tab-pane>
      <chc-tab-pane label="Disposition" v-if="user.user_role == 'admin' || user.user_role == 'charity'">
        <vehicle-disposition :data="dispositionData" :vehicleId="vehicleId" :refNum="data.ref_number" @refresh="refresh"></vehicle-disposition>
      </chc-tab-pane>
      <chc-tab-pane label="Notes" v-if="user.user_role == 'admin'">
        <vehicle-notes
          ref="vehicleNotes"
          v-on:addNote="addNote"
          :vehicleId="vehicleId"></vehicle-notes>
      </chc-tab-pane>
      <chc-tab-pane label="Change Log" v-if="user.user_role == 'admin'">
        <vehicle-change-log :vehicleId="vehicleId"></vehicle-change-log>
      </chc-tab-pane>
  </chc-tab-control>
</section>
</div>
</template>

<script>
import store from '@/store'
import auth from '@/auth'
import VehicleNotes from '@/components/Vehicle/VehicleNotes'
import VehicleAddNote from '@/components/Vehicle/VehicleAddNote'
import VehicleDonorInfo from '@/components/Vehicle/VehicleDonorInfo'
import VehicleDetailInfo from '@/components/Vehicle/VehicleDetailInfo'
import VehicleDisposition from '@/components/Vehicle/VehicleDisposition'
import VehicleProcessing from '@/components/Vehicle/VehicleProcessing'
import VehicleChangeLog from '@/components/Vehicle/VehicleChangeLog'

export default {
  name: 'Vehicle',
  data () {
    return {
      donorData: {},
      vehicleData: {},
      vehicleDetailData: {},
      processingData: {},
      dispositionData: {},
      data: {},
      user: auth.user,
    }
  },
  props: ['vehicleId'],
  beforeRouteEnter (to, from, next) {
    let vehicleData = null
    let donorData = null
    let vehicleDetailData = null
    let processingData = null
    let dispositionData = null
    let vals = [
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary'),
      store.functions.vehicles.getVehicleDonation(to.params.vehicleId, (response) => { vehicleData = response.data }),
      store.functions.vehicles.getVehicleDonorInfo(to.params.vehicleId, (response) => { donorData = response.data }),
      store.functions.vehicles.getVehicleDetailInfo(to.params.vehicleId, (response) => { vehicleDetailData = response.data }),
      store.functions.vehicles.getVehicleProcessingInfo(to.params.vehicleId, (response) => { processingData = response.data }),
      store.functions.vehicles.getVehicleDispositionInfo(to.params.vehicleId, (response) => { dispositionData = response.data }),
    ]
    Promise.all(vals).catch(() => {
      next(vm => vm.$router.push({name: 'VehiclesSummary'}))
    }).then(() => {
      next(vm => vm.setData(vehicleData, donorData, vehicleDetailData, processingData, dispositionData))
    })
  },
  methods: {
    setData (data, donorData, vehicleDetailData, processingData, dispositionData) {
      this.data = data
      this.donorData = donorData

      // transform all keys with location in the keyname to be in the same format for multi-select.
      for (let key in vehicleDetailData) {
        if (key.includes('location') && store.state.constants.vehicle[key]) {
          vehicleDetailData[key] = vehicleDetailData[key].map((location) => {
            return store.state.constants.vehicle[key].find(item => item.value === location)
          })
        }
      }
      this.vehicleDetailData = vehicleDetailData
      this.processingData = processingData
      this.dispositionData = dispositionData
    },
    addNote () {
      this.$refs.addNoteModal.show()
    },
    addNoteHide () {
      this.$refs.addNoteModal.hide()
    },
    refreshNotes () {
      this.$refs.vehicleNotes.refresh()
    },
    refresh () {
      let vehicleData = null
      let donorData = null
      let vehicleDetailData = null
      let processingData = null
      let dispositionData = null
      Promise.all([
        store.functions.vehicles.getVehicleDonation(this.vehicleId, (response) => { vehicleData = response.data }),
        store.functions.vehicles.getVehicleDonorInfo(this.vehicleId, (response) => { donorData = response.data }),
        store.functions.vehicles.getVehicleDetailInfo(this.vehicleId, (response) => { vehicleDetailData = response.data }),
        store.functions.vehicles.getVehicleProcessingInfo(this.vehicleId, (response) => { processingData = response.data }),
        store.functions.vehicles.getVehicleDispositionInfo(this.vehicleId, (response) => { dispositionData = response.data }),
      ]).then(() => {
        this.setData(vehicleData, donorData, vehicleDetailData, processingData, dispositionData)
      })
    }
  },
  computed: {
  },
  components: {
    VehicleNotes,
    VehicleAddNote,
    VehicleDonorInfo,
    VehicleDetailInfo,
    VehicleDisposition,
    VehicleProcessing,
    VehicleChangeLog
  }
}
</script>

<style>
.field.top-status {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/Vehicle.vue